import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _badgeProps;
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React from 'react';
import PropTypes from 'prop-types';
import { StatusBadge } from '../../common/badges';
import { INSURANCE_STATUSES } from './constants';
var badgeProps = (_badgeProps = {}, _defineProperty(_badgeProps, INSURANCE_STATUSES.pending_enrollment, {
  className: 'bg-medium-yellow text-dark-blue',
  label: 'Pending enrollment'
}), _defineProperty(_badgeProps, INSURANCE_STATUSES.enrolled, {
  className: 'bg-green text-white',
  label: 'Enrolled'
}), _defineProperty(_badgeProps, INSURANCE_STATUSES.not_enrolled, {
  className: 'bg-grey text-white',
  label: 'Not enrolled'
}), _defineProperty(_badgeProps, INSURANCE_STATUSES.rejected, {
  className: 'bg-red text-white',
  label: 'Rejected'
}), _defineProperty(_badgeProps, INSURANCE_STATUSES.pending_disenrollment, {
  className: 'bg-dark-pale-blue text-dark-blue',
  label: 'Pending disenrollment'
}), _badgeProps);
var validStatuses = _Object$keys(badgeProps);
export var InsuranceStatusIndicator = function InsuranceStatusIndicator(_ref) {
  var status = _ref.status;
  if (!_includesInstanceProperty(validStatuses).call(validStatuses, status)) return '';
  var _badgeProps$status = badgeProps[status],
    className = _badgeProps$status.className,
    label = _badgeProps$status.label;
  return /*#__PURE__*/React.createElement(StatusBadge, {
    className: className,
    "data-testid": "sccEnrollStatus",
    label: label
  });
};
InsuranceStatusIndicator.propTypes = {
  status: PropTypes.oneOf(validStatuses).isRequired
};
//# sourceMappingURL=InsuranceStatusIndicator.js.map